"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _asicsLogoWhite = _interopRequireDefault(require("../images/asics-logo-white.svg"));

var _brandFamilyBlack = _interopRequireDefault(require("../images/team-red/brand-family-black.svg"));

var _hero = _interopRequireDefault(require("../images/team-red/hero.png"));

var _membership = _interopRequireDefault(require("../images/team-red/membership.svg"));

var _weAre = _interopRequireDefault(require("../images/team-red/we-are.svg"));

var _stitches = require("../stitches.config");

var images = {
  blackBrandFamily: _brandFamilyBlack.default,
  description: _weAre.default,
  header: _membership.default,
  hero: _hero.default,
  brandLogo: _asicsLogoWhite.default
};
var theme = (0, _stitches.createTheme)('team-red', {
  background: {
    image: 'linear-gradient(#dd2c00, #dd2c00)'
  },
  buttonShape: {
    default: '$square'
  },
  colors: {
    inputBorder: '$grey600',
    inputBorderFocused: '$black',
    inputText: '$grey700',
    primary: '#dd2c00',
    primaryHover: '#f63000',
    primaryContrast: '$white',
    textPrimary: '$textBlack'
  }
});
var _default = {
  images: images,
  theme: theme
};
exports.default = _default;